import React, { useContext } from 'react';
import SspProviderContext from '../../../utils/SspProvider/context';
import SSPContentVO from 'sspcontentext/dist/model/SSPContentVO';
import VideoPlayer from '../../../components/VideoPlayer';
import SSPAssetDataSetAccessor from 'sspcontentext/dist/model/accessor/SSPAssetDataSetAccessor';
import DefaultCamflight from '../../../assets/images/DefaultCamflight.mp4';
import i18next from 'i18next';
import { introDone } from '../../../App';

export default function Overview(): JSX.Element {
    const store = useContext(SspProviderContext);
    const contentModel = store.state.content ? store.state.content.asModel : new SSPContentVO('').asModel;

    function renderMediaAsset(mediaAsset?: SSPAssetDataSetAccessor) {
        if (mediaAsset?.fileFamily === 'image') {
            return <img src={mediaAsset.url} alt='your-car' />;
        } else if (mediaAsset?.fileFamily === 'video') {
            return (
                <VideoPlayer
                    videoId='overview-video'
                    link={mediaAsset.url}
                    filetype={mediaAsset.fileProperties.fileType}
                    loopVideo={true}
                    hideControl={true}
                    placeholder={overviewAsset?.asAsset.posterUrl}
                    autoPlay={introDone}
                />
            );
        }
        return <></>;
    }

    let overviewAsset: SSPContentVO | undefined;

    if (contentModel.has('driving_scene_asset')) { // todo Use hook `useCachedVideo` instead? Start video at beginning when page becomes visible.
        overviewAsset = contentModel.ref('driving_scene_asset');
    } else {
        overviewAsset = contentModel.reflist('header_assets').find(asset => {
            return asset.asModel.isinStrlist('tags', 'front:left:false:');
        });
    }

    return (
        <div id='overview'>
            <div className='overview-img'>
                {overviewAsset ? (
                    renderMediaAsset(overviewAsset?.asAsset)
                ) : (
                    <VideoPlayer
                        link={DefaultCamflight}
                        filetype={'mp4'}
                        videoId={'overview-video'}
                        hideControl={true}
                        loopVideo={true}
                        autoPlay={introDone}
                    ></VideoPlayer>
                )}
            </div>
            <div className='overview-welcome'>
                <div className='overview-logo'>
                    <div className='logo-line' />
                    <svg>
                        <use xlinkHref='#vw-logo' />
                    </svg>
                    <div className='logo-line' />
                </div>
                <span>
                    <strong> {i18next.t('Your')}</strong>
                </span>
                {contentModel.str('title') !== undefined ? <span>{contentModel.str('title').replace(/\bDer Neue\b/gi, '').trim()}</span> : <span>--</span>}
                <div className='overview-welcome-text'>{i18next.t('OverviewWelcomeText')}</div>
            </div>
        </div>
    );
}
